// Set debug var
const localDebug = window.location.href.match(/(localhost|192\.168\.\d{1,3}\.\d{1,3})/);
const debugEnabled = Boolean(localDebug || window.location.href.match(/forcedebug=true/gi));

if (debugEnabled) {
  window.__debugEnabled = true;

  if (localDebug) {
    if (!localStorage.debugFlags) {
      localStorage.debugFlags = '{"$emit": true, "$on": true}';
    }
    window.__debugFlags = JSON.parse(localStorage.debugFlags);
  } else {
    window.__debugFlags = {
      $emit: window.location.href.match(/emitDebug=true/gi),
      $on: window.location.href.match(/onDebug=true/gi),
    };
  }
}

const debug = (flag, cb) => {
  if (debugEnabled && window.__debugFlags[flag]) cb();
}

export { debugEnabled };
export default debug;



// WEBPACK FOOTER //
// ./assets/js/source/utils/Debug.js